// =============================================================================
// app/src/componentes/CampoBusca.tsx — a caixa de busca das telas de lista.
//
// Irmão de Segmentado.tsx, pelo mesmo motivo: o padrão já existia em Estoque e
// Clientes, com placeholder e paddings diferentes em cada um. Aqui vira UM.
//
// O BOTÃO DE LIMPAR NÃO É ENFEITE: no celular, apagar 20 caracteres com o
// backspace enquanto o cliente espera é o tipo de atrito que faz o vendedor
// desistir do filtro e rolar a lista com o dedo. Ele só aparece com texto
// digitado — botão que não faz nada não ocupa espaço.
// =============================================================================

export default function CampoBusca({ valor, aoMudar, placeholder, id }: {
  valor: string;
  aoMudar: (v: string) => void;
  placeholder: string;
  id?: string;
}) {
  return (
    <div className="relative">
      <input
        id={id}
        type="search"
        className="campo pr-10"
        value={valor}
        onChange={(e) => aoMudar(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        // A busca é local (a lista já chegou): sem correção nem maiúscula
        // automática, que no celular transformam "gol" em "Gol" e "sku" em "Sku".
        autoCorrect="off"
        autoCapitalize="none"
        spellCheck={false}
      />
      {valor && (
        <button
          type="button"
          onClick={() => aoMudar('')}
          aria-label="Limpar busca"
          className="absolute top-1/2 right-2 -translate-y-1/2 px-2 py-1 text-lg leading-none text-dim hover:text-paper"
        >
          ×
        </button>
      )}
    </div>
  );
}
